import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'wouter';

import * as AppPropTypes from '../../../lib/PropTypes';

import StyledButton from '../../buttons/StyledButton';

import styles from '../../../../styles/themes/rhoneacademy/rhoneacademy-game-end.module.scss';

import headerSvg from '../../../../img/rhoneacademy/games/end-header.svg';

const propTypes = {
    game: AppPropTypes.game,
    participation: AppPropTypes.participation,
    questionsGroup: AppPropTypes.questionsGroup,
    className: PropTypes.string,
};

const defaultProps = {
    game: null,
    participation: null,
    questionsGroup: null,
    className: null,
};

function RhoneacademyGameEnd({ game, participation, questionsGroup, className }) {
    const route = useUrlGenerator();
    const [, navigate] = useLocation();
    const { locale } = useIntl();

    const onGoToModulesClicked = useCallback(() => {
        navigate(route('play'));
    }, [navigate, route]);

    const onGoToResultsClicked = useCallback(
        () => navigate(route('page', { page: locale === 'fr' ? 'resultats' : 'results' })),
        [navigate, route],
    );

    const { questions: questionsOfGroup = null } = questionsGroup;
    const { length: questionsCount } = questionsOfGroup || [];

    const { answers: participationAnswers = null } = participation || {};
    const correctCount = useMemo(
        () => (participationAnswers || []).filter((c) => c.valid).length,
        [questionsOfGroup],
    );

    const pointsForGroup = useMemo(
        () =>
            participationAnswers.reduce(
                (carry, { question: questionId = null, valid: answerIsValid = null }) => {
                    if (answerIsValid) {
                        const { points = null } =
                            (questionsOfGroup || []).find((q) => q.id === questionId) || {};
                        if (points !== null) {
                            return carry + points;
                        }
                    }
                    return carry;
                },
                0,
            ),
        [participationAnswers, questionsOfGroup],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.content}>
                <div className={styles.result}>
                    <img className={styles.img} src={headerSvg} alt="Correct" />
                    <h1>
                        {correctCount}/{questionsCount}
                    </h1>
                    <h2>
                        <FormattedMessage
                            defaultMessage="Let's drink to your knowledge!"
                            description="Rhone Academy - Feedback subtitle"
                        />
                    </h2>

                    <div className={styles.points}>+{pointsForGroup} points</div>
                </div>

                <StyledButton className={styles.leaderboardCTA} onClick={onGoToModulesClicked}>
                    <FormattedMessage
                        defaultMessage="Play another module"
                        description="Rhone Academy Game End Button"
                    />
                </StyledButton>

                <StyledButton className={styles.resultsCTA} onClick={onGoToResultsClicked}>
                    <FormattedMessage
                        defaultMessage="Go to results"
                        description="Rhone Academy Game End Button"
                    />
                </StyledButton>
            </div>
        </div>
    );
}

RhoneacademyGameEnd.propTypes = propTypes;
RhoneacademyGameEnd.defaultProps = defaultProps;

export default RhoneacademyGameEnd;
